import {hasRegistrationDraft} from './registration-draft';
import {platform} from '../platform/transport';
import {ownerHasUnsavedWork} from '../platform/unsaved-work';

// React-controlled fields can update defaultValue while a draft is still unsaved.
// Retain an edit guard for that field until it is removed or its form is reset.
const editedFields=new Set<Element>();
document.addEventListener('input',event=>{if(event.target instanceof Element)editedFields.add(event.target);},true);
document.addEventListener('change',event=>{if(event.target instanceof Element)editedFields.add(event.target);},true);
document.addEventListener('reset',event=>{if(event.target instanceof HTMLFormElement)for(const field of editedFields)if(event.target.contains(field))editedFields.delete(field);},true);

export function hasUnsavedEdits():boolean {
  if(hasRegistrationDraft()||ownerHasUnsavedWork())return true;
  for(const field of editedFields)if(!field.isConnected)editedFields.delete(field);
  if([...editedFields].some(field=>!field.closest('[data-unsaved-owner]')))return true;
  // Do not discard messages, selected files, edited forms or a password being entered.
  return [...document.querySelectorAll<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>('input,textarea,select')].filter(field=>!field.closest('[data-unsaved-owner]')).some(field=>
    field instanceof HTMLInputElement?field.type==='file'?Boolean(field.files?.length):['checkbox','radio'].includes(field.type)?field.checked!==field.defaultChecked:field.value!==field.defaultValue:
      field instanceof HTMLTextAreaElement?field.value!==field.defaultValue:[...field.options].some(option=>option.selected!==option.defaultSelected));
}
/** Read the published entry point before resuming an idle page after a deployment. */
export async function reloadChangedFrontend(idle:()=>boolean):Promise<boolean> {
  if(platform().kind==='desktop'||import.meta.env.DEV||!idle()||hasUnsavedEdits())return false;
  const current=document.querySelector<HTMLScriptElement>('script[type="module"][src]')?.src;
  if(!current)throw new Error('The loaded frontend has no module entry point.');
  const response=await fetch(`${import.meta.env.BASE_URL}index.html`,{cache:'no-store',credentials:'same-origin'});
  if(!response.ok)throw new Error(`Frontend version read failed: HTTP ${response.status} ${await response.text()}`);
  const html=new DOMParser().parseFromString(await response.text(),'text/html');
  const source=html.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute('src');
  if(!source)throw new Error('The published frontend has no module entry point.');
  const next=new URL(source,response.url);
  if(next.origin!==window.location.origin)throw new Error('The published frontend entry point has an unexpected origin.');
  if(next.href===current)return false;
  // A user can begin editing or start work while the version request is in flight.
  if(document.visibilityState!=='visible'||!idle()||hasUnsavedEdits())return false;
  window.location.reload();return true;
}
